var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-10 overflow-hidden"},[_c('Hero'),_c('div',{staticClass:"relative z-20"},[_c('Audiences'),_c('WhoWeHelp'),_c('HowWeHelp'),_c('RoadmapCarousel'),_c('JoinCuddle'),_c('TheTeam',{staticClass:"pb-10"}),_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }